import { Observable } from 'rxjs';

import { SfConnectorService, SfWorkContextService } from '@safra-frontend/core';
import { AlertaService } from '@shared/modules/alerta/alerta.service';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { IDetalheConsentimentoResources } from '@shared/utils/interfaces/home.interface';

export class ConsentResourceService {
  constructor(
    protected sfConnector: SfConnectorService,
    protected sfWorkContext: SfWorkContextService,
    protected alertaService: AlertaService
  ) {}

  getResources(conscentId: string, tokenId: string): Observable<any> {
    return this.sfConnector
      .execute('GET', `internal/get-resources-by-id/${conscentId}/${tokenId}`)
      .pipe(catchError((error: HttpErrorResponse) => this.alertaService.handleHttpError(error)));
  }

  getConsent(conscentId: string, tokenId: string): Observable<any> {
    return this.sfConnector
      .execute('GET', `internal/get-consent-by-key/${conscentId}/${tokenId}`)
      .pipe(catchError((error: HttpErrorResponse) => this.alertaService.handleHttpError(error)));
  }

  getConsentResources(consentId: string, tokenId: string): Observable<{ data: IDetalheConsentimentoResources }> {
    return this.sfConnector
      .execute<{ data: IDetalheConsentimentoResources }>('GET', `internal/get-consent-details/${consentId}/${tokenId}`)
      .pipe(catchError((error: HttpErrorResponse) => this.alertaService.handleHttpError(error)));
  }
}
